interface GetModuleBottomMarginStylesOptions {
    suppressMargin?: boolean;
}

const getModuleBottomMarginStyles = (
    isGrid = false,
    { suppressMargin = false }: GetModuleBottomMarginStylesOptions = {}
) => ({
    marginBottom: isGrid || suppressMargin ? 0 : 'var(--margin-bottom-module)',
});

export default getModuleBottomMarginStyles;
